import axios from "axios";
import { Apis } from "constants/apis";
import { GetPlansService } from "types/services";

const getPlans: GetPlansService = async() => {
    const { data } = await axios.get(Apis.GET_PLANS);
    return data
}

export default getPlans